import { render, staticRenderFns } from "./playad.vue?vue&type=template&id=153eb1bb&scoped=true"
import script from "./playad.vue?vue&type=script&lang=js"
export * from "./playad.vue?vue&type=script&lang=js"
import style0 from "./playad.vue?vue&type=style&index=0&id=153eb1bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153eb1bb",
  null
  
)

export default component.exports